export default __webpack_public_path__ + "static/media/3 - Boat ride from Kodiak to Spruce.e52c2d38.jpeg";